if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        if (!mediaId) return;

        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        const isDesktop = window.matchMedia('(min-width: 750px)').matches;
        if (container) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        }
        if (isDesktop) {
          activeMedia.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
